import { useMemo } from 'react'
import { LabRemoteConfigKeys } from 'constants/lab'
import { useLabRemoteConfig } from 'hooks/FeatureFlag/useLabRemoteConfig'
import { getLanguageOptions } from 'i18n/util/locale'
import { useAppSelector } from 'hooks/reduxHooks'
import { isLEStaff } from 'selectors/accountSelectors'

export function useLocaleUrlOptions() {
  const locale = useAppSelector(state => state.geo.locale)
  const isStaff = useAppSelector(isLEStaff)
  const languagesRemoteConfig = useLabRemoteConfig(LabRemoteConfigKeys.languages)
  const languageOptions = useMemo(
    () => getLanguageOptions(languagesRemoteConfig, isStaff),
    [isStaff, languagesRemoteConfig],
  )

  return {
    locale,
    ...languageOptions,
  }
}
